import api from './api';

// class with functions for user api calls
class UserService {

//get list of users
  getUsers() {
    return api.get('users/');
  }

  //get user by id
  getUser(id) {
    return api.get('users/profile');
  }

  //delete user
  deleteUser(user) {
    return api.delete('users/' + user);
  }

  //edit user
  editCurrentUser(newUser) {
    return api.put('users/', newUser);
  }

  //create a new user
  createNewUser(newUser) {
    return api.post('Users/create', newUser);
  }
}

export default new UserService();
